<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"></h5>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
          </div>
        </div>
        <div class="modal-body">
          <div class="px-8" id="printMailId">
            <div class="bg-light my-5 p-5" style="border-radius: 5px;">
              <div class="d-flex justify-content-between">
                <div>
                  <h2>{{mailItemPrint?.subject}}</h2>
                  <div class="row mb-2">
                    <span class="fs-6 col-12 col-md-2 col-lg-2">{{$t('mail.of')}} : </span>
                    <span class="fs-5 col-12 col-md-10 col-lg-10">{{mailItemPrint?.from?.personal + ', ' + mailItemPrint?.from?.mail}}</span>
                  </div>
                  <div class="d-flex mb-2" v-if="mailItemPrint?.to?.length > 0">
                    <span class="fs-6 col-12 col-md-2 col-lg-2">{{$t('mail.to')}} : </span>
                    <span class="fs-5 col-12 col-md-10 col-lg-10">
                      <span class="badge badge-light-primary me-2" v-for="(to, index) in mailItemPrint?.to" :key="index">{{ to.full ? to.full : to.mail }}</span>
                    </span>
                  </div>
                  <div class="d-flex mb-2" v-if="mailItemPrint?.date">
                    <span class="fs-6 col-12 col-md-2 col-lg-2">{{$t('mail.date')}} : </span>
                    <span class="fs-5 col-12 col-md-10 col-lg-10">{{mailItemPrint?.date ? $dateFormatterWithDay(mailItemPrint?.date, locale, true) : ''}}</span>
                  </div>
                  <div class="d-flex mb-2" v-if="mailItemPrint?.cc?.length > 0">
                    <span class="fs-6 col-12 col-md-2 col-lg-2">{{$t('mail.cc')}} : </span>
                    <span class="fs-5 col-12 col-md-10 col-lg-10">
                      <span class="badge badge-light-primary me-2" v-for="(cc, index) in mailItemPrint?.cc" :key="index">{{ cc.full ? cc.full : cc.mail }}</span>
                    </span>
                  </div>
                  <div class="d-flex" v-if="mailItemPrint?.bcc?.length > 0">
                    <span class="fs-6 col-12 col-md-2 col-lg-2">CCi : </span>
                    <span class="fs-5 col-12 col-md-10 col-lg-10">
                      <span class="badge badge-light-primary me-2" v-for="(bcc, index) in mailItemPrint?.bcc" :key="index">{{ bcc.full ? bcc.full : bcc.mail }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="card border_style">
                  <h4 v-if="mailItemPrint?.attachments?.length > 0" class="mb-5">{{$t('pipelines.attach_files')}}</h4>
                  <div v-if="mailItemPrint?.attachments?.length > 0" class="my-5">
                    <div class="row mb-3" v-for="(file, index) in mailItemPrint?.attachments" :key="index">
                      {{ file.name }}
                    </div>
                  </div>
                  <div v-if="mailItemPrint?.body_html" v-html="mailItemPrint?.body_html"></div>
                  <div v-if="!mailItemPrint?.body_html && mailItemPrint?.body_text">
                    <div style="width: 100%; border: none; height: 400px !important; white-space: pre-line;">
                      {{ mailItemPrint?.body_text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {computed, ref, watch} from "vue";
  import {$dateFormatterWithDay} from "@/mixins/Helpers";
  import {useLocales} from "@/composables/locales";

  const {locale} = useLocales()

  const props = defineProps({
    id: {
      type: String,
      default: ''
    },
    item: {
      type: String,
      default: ''
    },
  })


  const iframeRef = ref(null);
  const mailItemPrint = computed(() => props.item)

  watch(() => mailItemPrint.value?.body_html, (newHtml) => {
    if (iframeRef.value && newHtml) {
      const doc = iframeRef.value.contentDocument || iframeRef.value.contentWindow.document;
      doc.open();
      doc.write(newHtml);
      doc.close();
    }
  });
</script>

<style scoped>
  .spinner-overlay {
    background-color: rgba(255, 255, 255, 0.3);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .spinner {
    border: 6px solid #f3f3f3;
    border-top: 5px solid var(--bs-primary);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 2s linear infinite;
    margin-left: 48%;
    margin-top: 5%;
    margin-bottom: 10px;
  }
  .border_style {
    border: 2px solid var(--bs-light)
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>